import { SelectOption } from 'basics/options/options.types';
import { TimeSlot } from 'modules/events/basics/types/events.types';
import { CheckBoxYodaProps } from 'yoda-ui/Form/CheckBoxYoda';
import { DateRangePickerProps } from 'yoda-ui/Form/DateRangePicker';
import { SelectYodaInputProps } from 'yoda-ui/Form/SelectYoda/SelectYoda.types';
import { TextYodaInputProps } from 'yoda-ui/Form/TextYoda';

export type TimeSlotBookingProps = {
  onSave?: (values: TimeSlot) => void ;
  values?: TimeSlot;
  isLoading: boolean;
  isValid: boolean;
  isInvalid: boolean;
  disabled: boolean;
};

export enum TimeSlotBookingField {
  dateRange = 'dateRange',
  endTime = 'endTime',
  startTime = 'startTime',
  timeZone = 'timeZone',
  hostProvider = 'hostProvider',
  hostProviderLink = 'hostProviderLink',
  eventFormat = 'eventFormat',
  enableZoomStreaming = 'enableZoomStreaming',
  locale = 'locale',
}

export type TimeSlotBookingConfig = {
  dateRange: DateRangePickerProps;
  timeZone: SelectYodaInputProps;
  startTime: SelectYodaInputProps;
  endTime: SelectYodaInputProps;
  eventFormat: SelectYodaInputProps;
  hostProvider: SelectYodaInputProps;
  hostProviderLink: TextYodaInputProps;
  enableZoomStreaming: CheckBoxYodaProps;
  locale: SelectYodaInputProps;
};

export type UseTimeSlotBooking = Pick<TimeSlotBookingProps, 'onSave'>;

export type UseTimeSlotBookingConfigProps = {
  startTimeOptions: SelectOption[];
  endTimeOptions: SelectOption[];
  values?: TimeSlot;
};

